import { __awaiter, __generator } from "tslib";
export function shouldOpenInOfficeApp(appName) {
    return __awaiter(this, void 0, void 0, function () {
        var hwaNativeBridge;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import('@office-start/hwa-native-bridge-service')];
                case 1:
                    hwaNativeBridge = _a.sent();
                    return [2 /*return*/, hwaNativeBridge
                            .getInstalledApp(appName)
                            .then(function (appInfo) {
                            return appInfo !== null;
                        })
                            .catch(function () {
                            return false;
                        })];
            }
        });
    });
}
//# sourceMappingURL=shouldOpenInOfficeApp.js.map